// Header.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ads } from '../config/adsConfig';

import Tooltip from "./Tooltip";
import { FaBars, FaTimes, FaAngleDown, FaVideo } from "react-icons/fa";
import '../App.css';

function Header() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  // rotate ad every 15 seconds
  const [currentAd, setCurrentAd] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAd(i => (i + 1) % ads.length);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="header-container" style={{ height: '250px' }}>
      <div className="header-inner" style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <div className="logo">
          <a href="/">
            <img src="logo.png" alt="MTB-FEED" className="logo-image" />
          </a>
        </div>
        <div className="ad-container" style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center'
          }}>
          <a
            href={ads[currentAd].link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={ads[currentAd].image}
              alt="Advertisement"
              className="ad-image"
              style={{ maxHeight: '90px', objectFit: 'contain' }}
            />
          </a>
        </div>
      </div>

      {/* Mobile version */}
      <div className="mobile-only mobile-menu-button">
        <button
          onClick={() => setMobileMenuOpen(true)}
          style={{ background: 'transparent', border: 'none', fontSize: '1.8em', cursor: 'pointer', color: '#ccc' }}
        >
          <FaBars />
        </button>
      </div>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu">
            <button 
              onClick={() => setMobileMenuOpen(false)}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '1.5em',
                color: '#fff',
                position: 'absolute',
                top: '10px',
                right: '10px',
                cursor: 'pointer'
              }}
            >
              <FaTimes />
            </button>
            <div style={{ padding: '20px', color: '#fff', display: 'flex', flexDirection: 'column', gap: '15px' }}>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

const styles = {
  buyCreditsBtn: {
    padding: '6px 12px',
    backgroundColor: '#13A1A8',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '10px',
  },
  logoutBtn: {
    padding: '6px 12px',
    backgroundColor: '#d9534f',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  dropdownBtn: {
    padding: '6px 12px',
    backgroundColor: 'transparent',
    color: '#fff',
    border: '0px solid #fff',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.9em'
  },
  dropdownContent: {
    with: '300px',
    display: 'none',
    position: 'absolute',
    top: '100%',
    left: 0,
    backgroundColor: '#222',
    color: '#000',
    minWidth: '160px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
    zIndex: 9000,
    padding: '8px 0',
  },
  dropdownLink: {
    display: 'block',
    padding: '8px 12px',
    textDecoration: 'none',
    color: '#ddd',
    fontSize: '0.9em'
  }
};

export default Header;